import s from '@/components/Tables/KeywordsTable/KeywordsTable.module.scss';
import { RowSelectionState, Table } from '@tanstack/react-table';
import { DeleteIcon } from '@/assets';
import { OutlinedButton } from '@/components/layouts/Buttons/OutlinedButton/OutlinedButton';

interface Props<TableData> {
  table: Table<TableData>;
  isLoading?: boolean;
  extraActions?: JSX.Element;
  onDeleteSelected: (rowSelection: RowSelectionState) => void;
  onSelectAll?: () => Promise<void>;
}

export function TableActions<TableData extends object>({
  table,
  isLoading = false,
  extraActions,
  onDeleteSelected,
  onSelectAll,
}: Props<TableData>) {
  return (
    <section className={s.lowerOptions}>
      <OutlinedButton
        isLoading={isLoading}
        onClick={async (e) => {
          await onSelectAll?.();
          table.getToggleAllRowsSelectedHandler()(e);
        }}
      >
        Select All
      </OutlinedButton>
      <OutlinedButton isLoading={isLoading} onClick={() => table.setRowSelection({})}>
        Deselect All
      </OutlinedButton>
      <OutlinedButton
        isLoading={isLoading}
        onClick={() => onDeleteSelected(table.getState().rowSelection)}
        icon={DeleteIcon}
        iconAltText="delete icon"
        spinnerSize="20px"
        spinnerColor="#BA2634"
      >
        Remove Selected
      </OutlinedButton>
      {extraActions}
    </section>
  );
}
